import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const pains = ['Llegás cansada/o y no sabés qué cocinar que sea seguro y rápido', 'Armás la vianda con miedo a la contaminación cruzada', 'Gastás una fortuna en dietética cuando podrías hacerlo en casa', 'Tu hijo se queda afuera en cumpleaños y meriendas', 'La familia no entiende los cuidados y terminás repitiendo todo'];
export function PainPoints() {
  return <section className="w-full bg-cream px-5 py-16 sm:px-8 lg:py-24" data-id="element-112" data-mp="21zl8gf6u1l20">
      <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-[1fr_0.9fr] lg:gap-16" data-id="element-113" data-mp="1nzk0ygw2bfdk">
        <div data-id="element-114" data-mp="1syeq00kmi064">
          <SectionHeading align="left" eyebrow="La realidad de todos los días" title="¿Te suena conocido?" data-id="element-115" data-mp="1sy52cjn1w53l" />

          <ul className="mt-8 space-y-3" data-id="element-116" data-mp="3ibi6o8v5xt4p">
            {pains.map((pain, i) => <motion.li key={pain} initial={{
            opacity: 0,
            x: -16
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.4,
            delay: i * 0.07,
            ease: 'easeOut'
          }} className="flex items-start gap-3 rounded-2xl border border-forest/10 bg-cream-card p-4 text-forest-dark/85" data-id="element-117" data-mp="3nc5zn02yck1k" data-mpi={i}>
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-clay/12 text-clay" aria-hidden="true" data-id="element-118" data-mp="1g1t0dlhsrp53">
                  <XIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-119" data-mp="1p2hf6if0ltj1" />
                </span>
                <span className="leading-relaxed" data-id="element-120" data-mp="1p04nhdjgg4ss">{pain}</span>
              </motion.li>)}
          </ul>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} className="mt-8 border-l-4 border-forest pl-5 font-display text-2xl leading-snug text-forest-dark sm:text-[1.75rem]" data-id="element-121" data-mp="30he3fq3dkepc">
            No es falta de esfuerzo.
            <br data-id="element-122" data-mp="225tqb7tvv6bh" />
            <span className="text-forest" data-id="element-123" data-mp="225bkpklbzfqw">Es falta de un sistema.</span>
          </motion.p>
        </div>

        <div className="overflow-hidden rounded-3xl border border-forest/10 shadow-soft" data-id="element-124" data-mp="275g1zcu2cei6">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/f3ecd2ac-6adf-4709-bc11-20fd400ee3c6.jpg" alt="Mamá e hijo cocinando juntos en la cocina de casa" className="h-full w-full object-cover" loading="lazy" data-id="element-125" data-mp="1aex95v0sifie" />
        </div>
      </div>
    </section>;
}